/**
 * Centralized Color Palette
 * Modern gradient-based design system with glassmorphic aesthetics
 */

// Primary gradient colors
export const PRIMARY = {
  main: '#667eea',
  light: '#8b9ef8',
  dark: '#4a5fe8',
  gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
};

// Secondary gradient colors
export const SECONDARY = {
  main: '#764ba2',
  light: '#a58ad4',
  dark: '#6b4fc2',
  gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
};

// Dark mode backgrounds
export const DARK_BG = {
  primary: '#0a0e27',
  secondary: '#1a1f3a',
  gradient: 'linear-gradient(135deg, #0a0e27 0%, #1a1f3a 50%, #0a0e27 100%)',
  radial:
    'radial-gradient(circle at top right, rgba(102, 126, 234, 0.1), transparent 50%)',
};

// Light mode backgrounds
export const LIGHT_BG = {
  primary: '#f8f9ff',
  // Used by MUI `Paper` and by dropdown menus (`Select`, `Menu`, `Popover`).
  // Must be opaque in light mode to avoid see-through menus.
  paper: '#ffffff',
  gradient: 'linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%)',
};

// Common colors
export const COLORS = {
  white: '#ffffff',
  black: '#000000',
  purple: {
    light: '#a78bfa',
    lighter: '#c084fc',
    lightest: '#f0abfc',
  },
  blue: {
    main: '#2563eb',
    light: '#60a5fa',
  },
  green: {
    main: '#10b981',
    light: '#4ade80',
  },
  orange: {
    main: '#f59e0b',
    light: '#fbbf24',
  },
};

// Glassmorphic effects
export const GLASS = {
  background: theme =>
    theme === 'dark' ? 'rgba(30, 35, 55, 0.6)' : 'rgba(255, 255, 255, 0.7)',
  backdropFilter: 'blur(10px)',
  border: theme =>
    theme === 'dark'
      ? '1px solid rgba(255, 255, 255, 0.1)'
      : '1px solid rgba(0, 0, 0, 0.05)',
};

// Shadow effects
export const SHADOWS = {
  card: '0 8px 32px rgba(0, 0, 0, 0.1)',
  cardHover: '0 12px 48px rgba(0, 0, 0, 0.15)',
  glass: theme =>
    theme === 'dark'
      ? '0 8px 32px rgba(0, 0, 0, 0.3)'
      : '0 8px 32px rgba(31, 38, 135, 0.15)',
  gradient: '0 8px 32px rgba(102, 126, 234, 0.2)',
};

// Border colors
export const BORDERS = {
  light: 'rgba(255, 255, 255, 0.1)',
};

// Accent colors for status indicators
export const ACCENTS = {
  success: '#4caf50',
  warning: '#ff9800',
  error: '#f44336',
  info: '#2196f3',
};

export default {
  PRIMARY,
  SECONDARY,
  DARK_BG,
  LIGHT_BG,
  COLORS,
  GLASS,
  ACCENTS,
  SHADOWS,
  BORDERS,
};
